module.exports = __webpack_public_path__ + "6d1191d2e3d0f243662dbfb0723d9d59.fbx";